'use strict';

var SceneEnter = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneEnter ()
  {
    Phaser.Scene.call(this, { key: 'sceneEnter', active: false });
  },

  init: function(params){
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    this.sceneBoot.currentScene = 'sceneEnter';

    this.sceneBoot.scaleMode = 'full';
    this.scaler.scaleMode = 'full';

    this.scene.bringToTop();

    this.sceneBoot.windowResized = true;

    this.scene.launch('sceneVideo');

    this.clickedEnterBtn = false;
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    this.homeGroup = this.createHomeGroup();
    
    this.enterActionGroup;
    
    if(this.params && this.params.personal) { // 个人展位
      this.enterActionGroup = this.createBtnEnterPersonalGroup();
    } else if(this.params && this.params.system) { // 系展位
      this.enterActionGroup = this.createBtnEnterSystemGroup();
    } else {
      this.enterActionGroup = this.createBtnEnterGroup();
    }
    
    this.input.on('pointerup', function () {
      utils.updateButtonsAlpha(this);
    }, this);

    this.sceneBoot.windowResized = true;

    if(this.params && this.params.personal){
      //个人展位
      self.showBtnAnimation();
    } else if(this.params && this.params.system){
      //系长廊
      self.showBtnAnimation();
    }else{
      //正常模式
      self.getCookie();
    }

    designX = -7.5;
    designY = 430.5;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'center'),
      this.scaler.scaleY(designY),
      'start',
      0
    );
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'center',
      designX: designX,
      designY: designY,
      scaleX: -1,
    };
    this.animationSprite = sprite;
    sprite.scaleX *= -1;

    this.circleAnimation();
    
    this.enterAnimation();

    this.scene.get('sceneLoading').closeLoadingMask();
    this.scene.get('sceneLoading').moveRight();
  },

  update: function(){

  },

  resized: function () {
    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.keepData.offset == 'x') {
          s.keepData.designX = s.keepData.initialX + window.sidebarOffset;
        }

        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSprite(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else {
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else if(s.keepData.scaleByMax){
            this.scaler.scaleSpriteByMax(s);
          }else{
            this.scaler.scaleSprite(s);
          }


          if(s.keepData.scale){
            s.scale *= s.keepData.scale;
          }

          if(s.keepData.scaleX){
            s.scaleX *= s.keepData.scaleX;
          }
        }
      }
    }
  },

  createHomeGroup: function(){
    var self = this;
    var designX, designY, sprite;

    var group = this.add.group();

    designX = window.sidebarOffset;
    designY = 0;
    var sprite = this.add.image(
      this.scaler.scaleBgX(designX),
      this.scaler.scaleY(designY),
      'text_start_left'
    );
    sprite.setOrigin(0, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'left',
      ylocation: 'top',
      locationByBg: true,
      designX: designX,
      designY: designY,
      offset: 'x',
      initialX: 0,
    };
    group.add(sprite);

    designX = 0;
    designY = 0;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'text_start_right');
    sprite.setOrigin(1, 0);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      ylocation: 'top',
      designX: designX,
      designY: designY
    };
    group.add(sprite);

    return group;
  },

  createBtnEnterGroup: function() {
    let designX, designY, sprite;
    let group = this.add.group();

    designX = -0;
    designY = 704.5;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'center'),
      this.scaler.scaleY(designY),
      'btn_enter');
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'center',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    this.btnEnterSprite = sprite;
    var btnEnterSprite = sprite;
    group.add(sprite);

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      btnEnterSprite.setAlpha(0.5);
      btnEnterSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      btnEnterSprite.setAlpha(1.0);
      if(btnEnterSprite.isPressed) {
        this.clickEnterButton();
      }
      btnEnterSprite.isPressed = false;
    });
    return group;
  },

  createBtnEnterPersonalGroup: function() {
    let designX, designY, sprite;
    let group = this.add.group();

    designX = -160;
    designY = 750;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_enter_personal');
    sprite.setOrigin(1, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    var btnEnterSprite = sprite;
    group.add(sprite);

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      btnEnterSprite.setAlpha(0.5);
      btnEnterSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      btnEnterSprite.setAlpha(1.0);

      if(btnEnterSprite.isPressed) {
        this.clickPersonalEnterButton();
      }
      btnEnterSprite.isPressed = false;
    });

    designX = -266;
    designY = 767;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      this.params.personal.texture);
    sprite.setOrigin(1, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    group.add(sprite);

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      btnEnterSprite.setAlpha(0.5);
      btnEnterSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      btnEnterSprite.setAlpha(1.0);

      if(btnEnterSprite.isPressed) {
        this.clickPersonalEnterButton();
      }
      btnEnterSprite.isPressed = false;
    });

    return group;
  },

  createBtnEnterSystemGroup: function() {
    let designX, designY, sprite;
    let group = this.add.group();

    designX = -160;
    designY = 750;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'right'),
      this.scaler.scaleY(designY),
      'btn_enter_system_' + this.params.systemIndex);
    sprite.setOrigin(1, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      xlocation: 'right',
      designX: designX,
      designY: designY,
      enableClick: true,
      alpha: 1,
    };
    var btnEnterSprite = sprite;
    group.add(sprite);

    sprite.setInteractive();

    sprite.on("pointerdown", pointer => {
      btnEnterSprite.setAlpha(0.5);
      btnEnterSprite.isPressed = true;
    });

    sprite.on("pointerup", pointer => {
      btnEnterSprite.setAlpha(1.0);

      if(btnEnterSprite.isPressed) {
        this.clickSystemEnterButton();
      }
      btnEnterSprite.isPressed = false;
    });
    return group;
  },

  clickEnterButton: function() {
    utils.disableAllButtons(this);
    // this.outAnimation();
    // this.scene.launch('sceneVideo');
    this.btnEnterSprite.setVisible(false);
    this.fadeoutAnimation();
    this.clickedEnterBtn = true;
    this.scene.get('sceneVideo').videoPlay();
  },

  clickPersonalEnterButton: function() {
    window.custom.locator = this.params.locator;

    this.scene.get('sceneVideo').scene.stop();

    utils.disableAllButtons(this);
    this.scene.start(
      'sceneSystemPreface',
      {
        autoJump: 'personal',
        systemIndex: this.params.systemIndex,
        categoryIndex: this.params.categoryIndex,
      }
    );
  },

  clickSystemEnterButton: function() {
    utils.disableAllButtons(this);

    this.scene.get('sceneVideo').scene.stop();

    this.scene.get('sceneTitle').scene.setVisible(true);
    this.scene.get('sceneTitle').cameras.main.alpha = 1;
    this.scene.get('sceneTitle').enterAnimation();
    
    this.scene.launch('sceneArea', {noAnimation: true, isSystem: true});

    this.scene.start(
      'sceneSystemPreface',
      {
        autoJump: 'system',
        systemIndex: this.params.systemIndex,
      }
    );
  },

  getCookie: function(){
    var self = this;
    var selected = null;
    try {
      selected = JSON.parse(decodeURIComponent(utils.getCookie('selected')));
    }
    catch(err) {
      console.log(err);
    }
  
    window.custom.locator = utils.getCookie('locator');

    if(
      selected == null ||
      !(selected.systemIndex >= 0 && selected.systemIndex <= 11) ||
      !(selected.categoryIndex >= 0 && selected.categoryIndex <= 1)
    ){
      self.showBtnAnimation();
      return;
    }
  
    window.custom.selected = selected;
  
    window.custom.noTip = true;

    this.scene.get('sceneVideo').scene.stop();
    
    this.scene.start('sceneSystemPreface', {
      autoJump: 'personal',
      systemIndex: selected.systemIndex,
      categoryIndex: selected.categoryIndex
    });
  },
  
  showBtnAnimation: function(){
    var self = this;
    this.enterActionGroup.setVisible(true);
    this.enterActionGroup.getChildren().forEach((s, index) => {
      this.tweens.add({
        targets: s,
        alpha: {
          start: 0,
          to: s.keepData.alpha
        },
        // y: {
        //   from: this.scaler.scaleY(s.keepData.designY - 30),
        //   to: this.scaler.scaleY(s.keepData.designY)
        // },
        duration: 1000,
        delay: 0,
        ease: 'Linear',
        repeat: 0,
        yoyo: false,
        onComplete: function () {
        },
      }); 
    });
  },

  circleAnimation: function(){
    var frame = 0;
    var totalFrame = 180;
    this.circleAnimationTimer = this.time.addEvent({
      delay: 1000/30,
      callback: function(){
        frame ++;
        
        if(frame > totalFrame - 1){
          frame = 0;
        }
        
        this.animationSprite.setFrame(frame);
      },
      callbackScope: this,
      loop: true
    });

  },

  enterAnimation: function() {
    var self = this;
    var duration = 1000;//GC.animationDuration;
    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 0.2,
        to: 1
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    }); 
  },

  outAnimation: function() {
    var self = this;
    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.cameras.main,
      alpha: {
        start: 1,
        to: 0
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
        // self.scene.stop();
      },
    }); 
  },

  fadeoutAnimation: function() {
    var self = this;
    var duration = 3000;
    this.tweens.add({
      targets: this.homeGroup.getChildren(),
      alpha: {
        start: 1,
        to: 0
      },
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    }); 
  },
});
export default SceneEnter;